
















import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import dialogComp from "../index.vue";
import { Button } from "mint-ui";
import squareComp from "@/components/square/index.vue";
import { lottery } from "@/api/main";
import loginDialog from "@/components/dialog/login/index";
import giftDialog from "@/components/dialog/prize/index"
@Component<Square>({
  components: {
    dialogComp,
    squareComp,
    "mt-button": Button,
  },
})
export default class Square extends Vue {
  public uname: string = "";
  public prizePos: number = -1;
  public prizeName: string = "";
  public isLottery: boolean = false;
  public lotteryKey: string = "";
  public userPhone:string= "";
  public params: any = {
    name: "",
    phone: localStorage.getItem("ad/phone") || "",
    province: undefined,
    city: undefined,
    agentName: undefined,
  };
  public prizeList: any = {
    TRAVEL_PACKAGE: [0, 3],
    CONSUME_100: [1, 6],
    CONSUME_200: [4, 7],
    CONSUME_500: [2, 5],
    length: 4,
  };
  public show() {
    (this.$refs.dialog as any).show();
  }
  public successCb() {
    giftDialog({
      prizeCode:this.prizeName
    })
  }
  public lotteryCb() {
    lottery({ lotteryKey: this.lotteryKey }).then((res: any) => {
      window._hmt.push(["_trackPageview", "/#/lottery"]);
      if (res.code == 400) {
        loginDialog({
          userPhone:this.userPhone,
          callback: () => {
            this.lotteryCb();
          },
        });
      }else if(res.code!=200){
        (this as any).$dialog.alert({
            message: res.message
        })
      } else {
        var prizePosList = this.prizeList[res.data.prizeCode];
        this.prizePos =
          prizePosList[Math.floor(Math.random() * prizePosList.length)];
        this.prizeName = res.data.prizeCode;
        this.isLottery = true;
      }
    });
  }
  public close() {
    (this.$refs.dialog as any).close();
  }

  public goUrl() {
    location.href =
      "https://event.qunar.com/qm/qunargiftnew/index.htm?activityNo=tongyongh5&bdsource=tongyong";
  }

  public submitAppointCallback() {
    this.close();
  }
}
